module.exports = __webpack_public_path__ + "static/footer-bg-26a1619dd3be56462da2f7c9dae9a5c1.webp";